import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoObjectTbmBoundaryModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoObjectTbmBoundaryModel._instance == null) GeoObjectTbmBoundaryModel._instance = new GeoObjectTbmBoundaryModel(authManager);
        return GeoObjectTbmBoundaryModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-object-tbm-boundaries');

        this.entityName = 'model-sections.GeoObjectTbmBoundary';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Tbm Level';
        this.setLabel = 'Tbm Levels';

        this.browser = {
            name: 'default-model-sections-geoobjecttbmboundary-browser',
            moduleName: 'default-model-sections-geoobjecttbmboundary-browser',
            moduleTitle: 'Tbm Levels',
            moduleStateSlotName: 'default-model-sections-geoobjecttbmboundary-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoobjecttbmboundary-editor',
            moduleName: 'default-model-sections-geoobjecttbmboundary-editor',
            moduleTitle: 'Tbm Level',
            moduleStateSlotName: 'default-model-sections-geoobjecttbmboundary-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'boundaryTypeId',
                type: 'GeoBoundaryType',
                persistent: true,
                label: 'Boundary Type',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'elevation',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
                description: 'only for info (check)',
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'objectTbmId',
                type: 'GeoObjectTbm',
                persistent: true,
                label: 'Object Tbm',
            },
            {
                name: 'tbmAxisElevation',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Tbm Axis Elevation',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tbmExcavationDiameter',
                type: 'float',
                persistent: false,
                unit: 'm',
                label: 'Tbm Excavation Diameter',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'levelAboveTbmAxis',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Level Above Tbm Axis',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'levelAboveTbmAxisGiven',
                type: 'float',
                persistent: true,
                unit: 'm',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'pressureSensorId',
                type: 'GeoObjectTbmSensor',
                persistent: true,
                label: 'Pressure Sensor',
            },
            {
                name: 'pressureSensorLevelAboveTbmAxis',
                type: 'float',
                persistent: false,
                unit: 'm',
                label: 'Pressure Sensor Level Above Tbm Axis',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'requiredMinimumSupportForceAtTunnelAxisFaxis1CalcEnabled',
                type: 'bool',
                persistent: true,
                label: 'Required Minimum Support Force At Tunnel Axis Faxis 1 Calc Enabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'requiredMinimumSupportPressureP1CalcEnabled',
                type: 'bool',
                persistent: true,
                label: 'Required Minimum Support Pressure P 1 Calc Enabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'totalMinimumVerticalStressAtTunnelCrownPcrown1CalcEnabled',
                type: 'bool',
                persistent: true,
                label: 'Total Minimum Vertical Stress At Tunnel Crown Pcrown 1 Calc Enabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tunnelFaceRequiredSupportWaterForceInclSafetyCoefWcisCalcEnabled',
                type: 'bool',
                persistent: true,
                label: 'Tunnel Face Required Support Water Force Incl Safety Coef Wcis Calc Enabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tunnelFaceRequiredSupportEarthForceInclSafetyCoefEmaxcisCalcEnabled',
                type: 'bool',
                persistent: true,
                label: 'Tunnel Face Required Support Earth Force Incl Safety Coef Emaxcis Calc Enabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'requiredMinimumSupportForceAtTunnelAxisInclSafetyCoefFaxis2SCalcEnabled',
                type: 'bool',
                persistent: true,
                label: 'Required Minimum Support Force At Tunnel Axis Incl Safety Coef Faxis 2 S Calc Enabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
